module.exports = __webpack_public_path__ + "static/media/15.4829cd4a.png";